export const registerInitializer = (initializer) => {
  // $(document).ready(() => initializer());
  $(document).on('turbolinks:load', () => initializer());
};
